import React, { useEffect } from 'react';
import { Box, Typography, Breadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ServiceCard from '../components/ServiceCard';
import Header from '../components/Header';
import { Link , useParams } from 'react-router-dom';
import { useCompanyData } from '../../shared/contexts/DataContext';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { servicesImage } from '../../shared/logic/imagesFns';

const useStyles = makeStyles(() => ({
  breadWhite:{
    color:'#fff',
    fontSize:'1.3rem'
  }
}));

const Categories = () => {
  const { data } = useCompanyData();
  const { t, companyDomain, displayBanner=true } = data;
  const { id } = useParams();
  const classes = useStyles();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[id])

  return (
    <div>
      <Header image={servicesImage(data)} 
        data={data}
        height="400px"
        title={t && t('companyPage.category')}
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={displayBanner}
        titleColor='#ffffff'
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:data?.fontFamily}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem'}}>{t && t('companyPage.category')}</Typography>
        </Breadcrumbs>
      </Header>
      
      <ServicesList categories={data.categories} data={data} />
    </div>
  );
};

const ServicesList = ({ categories,data }) => {
  const { setPage, count, currentItems } = useMyPagination(categories, 6);
  const displayDescription = data.displayProductDesc !== undefined ? data.displayProductDesc : true;
  const companyId = data.companyData ? data.companyData.companyId : '';

  return (
    <Box bgcolor="#fafafa">
      <Box py={5} width="90%" m="auto">
        <Box display="flex" flexWrap="wrap" justifyContent="center">
          {currentItems?.map((item, i) => (
            <ServiceCard key={i} service={item} {...{displayDescription,productType:'categories',companyId}} />
          ))}
        </Box>
        <MyPagination count={count} onChange={setPage} />
      </Box>
    </Box>
  );
};

export default Categories;
